<template>
  <div>
    <h1>TEST</h1>
    <div>
      <v-select
        :items="['timeBase','pointBase']"
        v-model="boardType"
        label="Select"
        single-line
        bottom
      />
    </div>
    <!--<div>{{ match.sets[0].events }}</div>-->
    <MatchCard 
      :current-user="currentUser"
      :match="match"
      :sport="getSport(match)"
      :admin-mode="isClubAdmin"
      :editor-mode="isClubEditor"
      :viewer-mode="isClubViewer"
      :logged-mode="isLoggedUser" 
      :display-sets="true"
      :hidde-details="true"
      :display-charts="true"
      @onUpdate="onUpdateMatch"
      @onSendEvent="onSendEvent"
      @onToogleBlockMatch="onToogleBlockMatch"
      @onRemoveLastEvent="onRemoveLastEvent"/>
  </div>
</template>

<script>
import MatchesLib from '@/lib/data/matches'
import MatchCard from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard'
// import _ from 'lodash'
const debug = require('debug')('OD::TestSports')

export default {
  name: 'TestSports',
  components: { MatchCard },
  props: {},
  data() {
    return {
      authorized: true,
      boardType: 'pointBase',
      match: {
        id: 'XXXXX',
        localTeam: 'Team A',
        visitorTeam: 'Team B',
        location: 'In my place',
        category: 'My category',
        date: '2018-10-10',
        hour: '21:00',
        clubId: 'AAA',
        year: '2018',
        week: '10',
        sets: [
          { l: 0, v: 0, events: [] },
          { l: 0, v: 0, events: [] },
          { l: 0, v: 0, events: [] },
          { l: 0, v: 0, events: [] },
          { l: 0, v: 0, events: [] },
        ],
      },
    }
  },
  computed: {
    isClubAdmin() {
      return this.authorized
    },
    isClubEditor() {
      return this.authorized
    },
    isClubViewer() {
      return this.authorized
    },
    isLoggedUser() {
      return this.authorized
    },
    currentUser() {
      return {
        uid: 'xxxxxxx',
        displayName: 'Test user',
      }
    },
  },
  watch: {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    getSport(match) {
      switch (this.boardType) {
        case 'pointBase':
          return {
            type: 'pointBase',
            pointControls: [
              {
                text: 'SA',
                description: 'Saque',
                icon: '',
                num: 1,
                action: 'point',
                color: 'green',
              },
              {
                text: 'AT',
                description: 'Ataque',
                icon: '',
                num: 1,
                action: 'point',
                color: 'green',
              },
              {
                text: 'BL',
                description: 'Bloqueo',
                icon: '',
                num: 1,
                action: 'point',
                color: 'green',
              },
              {
                text: 'FS',
                description: 'Fallo de saque',
                icon: '',
                num: 1,
                action: 'point',
                color: 'red',
              },
              {
                text: 'FA',
                description: 'Fallo de ataque',
                icon: '',
                num: 1,
                action: 'point',
                color: 'red',
              },
              {
                text: 'FF',
                description: 'Fallo',
                icon: '',
                num: 1,
                action: 'point',
                color: 'red',
              },
              {
                text: 'RO',
                description: 'Falta de rotación',
                icon: '',
                num: 1,
                action: 'point',
                color: 'red',
              },
              {
                text: 'TR',
                description: 'Tarjeta Roja',
                icon: '',
                num: 1,
                action: 'point',
                color: 'red',
              },
            ],
            numSetsToWin: 3,
            numSetsToPlay: 3,
            regularSetPointsToWin: 3, // 25,
            lastSetPointsToWin: 2, // 15,
            setMinDifferenteToWin: 2,
            maxNumSets: 5,
            downtimeBySet: 2,
            actionControls: [
              {
                text: 'TM',
                description: 'Tiempo muerto',
                icon: '',
                color: 'brown',
                action: 'downtime',
              },
              {
                text: 'CA',
                description: 'Cambio',
                icon: '',
                color: 'blue',
                action: 'change',
              },
              {
                text: 'TA',
                description: 'Tarjeta amarilla',
                icon: '',
                color: 'orange',
                action: 'change',
              },
            ],
            timeControls: [],
            globalControls: [
              {
                text: '',
                description: '',
                icon: 'remove',
                color: 'red',
                action: 'remove',
              },
            ],
          }
        case 'timeBase':
          return {
            type: 'timeBase',
            pointControls: [
              {
                text: 'T',
                description: 'Transformación',
                icon: '',
                num: 2,
                action: 'point',
                color: 'green',
              },
              {
                text: 'PC',
                description: 'Puntapié de castigo',
                icon: '',
                num: 3,
                action: 'point',
                color: 'green',
              },
              {
                text: 'DR',
                description: 'Drop',
                icon: '',
                num: 3,
                action: 'point',
                color: 'green',
              },
              {
                text: 'EC',
                description: 'Ensayo de castigo',
                icon: '',
                num: 5,
                action: 'point',
                color: 'green',
              },
              {
                text: 'EN',
                description: 'Ensayo',
                icon: '',
                num: 5,
                action: 'point',
                color: 'green',
              },
            ],
            numPeriods: 2,
            numMinutesPerPeriod: 40,
            numMinutesForLastPeriod: 40,
            numPeriodsPerGroup: 1,
            numDownTimesPerGroupPeriod: 0,
            actionControls: [
              {
                text: 'TA',
                description: 'Tarjeta Amarilla',
                icon: '',
                time: '10',
                color: 'orange',
                action: 'yellow-card',
              },
              {
                text: 'TR',
                description: 'Tarjeta Roja',
                icon: '',
                time: 'out',
                color: 'red',
                action: 'red-card',
              },
            ],
            timeControls: [
              {
                text: '',
                description: 'Start',
                icon: 'play_arrow',
                color: 'orange',
                action: 'start',
              },
              {
                text: '',
                description: 'Pause',
                icon: 'pause',
                color: 'orange',
                action: 'pause',
              },
              {
                text: '',
                description: 'Stop',
                icon: 'stop',
                color: 'orange',
                action: 'stop',
              },
            ],
            globalControls: [
              {
                text: '',
                description: '',
                icon: 'remove',
                color: 'red',
                action: 'remove',
              },
            ],
          }
        default:
          return null
      }
    },
    onUpdateMatch(newItem, item) {
      debug('onUpdateMatch', newItem, item)
    },
    onSendEvent(data) {
      debug('onSendEvent', data)
      const processedData = MatchesLib.proccessEvent(
        this,
        Object.assign(
          {
            match: this.match,
            user: this.currentUser,
          },
          data
        )
      )
      if (processedData) {
        this.match = Object.assign({}, this.match, processedData)
      }
    },
    onRemoveLastEvent(data) {
      debug('onRemoveLastEvent', data)
      const processedData = MatchesLib.removeEvent(
        this,
        Object.assign(
          {
            match: this.match,
            user: this.currentUser,
          },
          data
        )
      )
      if (processedData) {
        this.match = Object.assign({}, this.match, processedData)
      }
    },
    onToogleBlockMatch(data) {
      debug('onToogleBlockMatch', data)
    },
    addPoint(team, i) {
      const events = this.match.sets[i].events.slice(0)
      events.push({
        matchId: this.match.id,
        action: 'point',
        set: i,
        team,
      })
      this.match.sets[i].events = events
    },
  },
}
</script>

<style lang="scss">

</style>
